import React, { Component } from 'react';

import AdminImage from './AdminImage.js';

import ImageUploader from './ImageUploader.js';
import Checkbox from './Checkbox.js';
import Button from './Button.js';
import ObjectController from './ObjectController.js';
import './AdminController.css';

import Input from './Input.js';
import Login from './Login.js';
import firebase from './fire.js';

const storage = firebase.storage();


class AdminController extends Component {

  constructor(props){
    super(props);

    let activeImgId = (this.props.activeImgId) ? this.props.activeImgId : Object.keys(this.props.data.project.images)[0];
    console.log('ADMINCONTROLLER: ', this.props.activeObjectId);
    this.state = ({
      projects: this.props.projects,
      data: this.props.data,
      objects : (this.props.data.items)?this.props.data.items:{},
      users : this.props.users,
      activeObjectId:this.props.activeObjectId ? this.props.activeObjectId : null,
      showAreaView: this.props.activeObjectId ? false : true,
      imgId: activeImgId,
      sortOnClicks:false
    });

    this.ObjectController = null;
    this.ObjectAreas = null;

    this.handleUser = this.handleUser.bind(this);
    this.handleUserCreatedFromAdmin = this.handleUserCreatedFromAdmin.bind(this);
    this.resetUser = this.resetUser.bind(this);

    this.uploadFile = this.uploadFile.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.saveDataToDatabase = this.saveDataToDatabase.bind(this);
    this.saveUserToDatabase = this.saveUserToDatabase.bind(this);
    this.getBannerImage = this.getBannerImage.bind(this);
    this.getImageUploader = this.getImageUploader.bind(this);
    this.getItems = this.getItems.bind(this);
    this.getAdminButtons = this.getAdminButtons.bind(this);


    this.handleReverseButtons = this.handleReverseButtons.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handlePermissionChange = this.handlePermissionChange.bind(this);
    this.createNewObject = this.createNewObject.bind(this);
    this.getObjectId = this.getObjectId.bind(this);
    this.updateState = this.updateState.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleDuplicateClick = this.handleDuplicateClick.bind(this);
    this.toggleAreaView = this.toggleAreaView.bind(this);
    this.handleProjectEmail = this.handleProjectEmail.bind(this);
    this.saveProjectEmail = this.saveProjectEmail.bind(this);

  }

  componentWillUpdate(props, state){

    // if( this.props.activeImgId !== state.imgId ){
    //   this.setState({
    //     imgId: state.imgId
    //   })
    // }

    console.log(' | - | - | - | - | - | - |');
    console.log('will update: ', state.activeObjectId);
    console.log('will update: ', (state.objects[state.activeObjectId] ));

    if(state.activeObjectId && (state.objects[state.activeObjectId] ) && state.user ){
console.log('hämtar ObjectController');
      this.ObjectController = <ObjectController projectId={this.props.projectId} user={props.users[state.user.id]} data={props.data} saveObject={this.updateState} id={state.activeObjectId}  />;

      // this.ObjectAreas = <AdminImage viewBox={this.props.viewBox} updateParentState={this.updateState} data={props.data}/>;
    }
    else if (state.showAreaView) {
      // this.ObjectAreas = <AdminImage viewBox={this.props.viewBox} updateParentState={this.updateState} data={props.data}/>;
    }

    if( state.user && props.users[state.user.id].role !== 'admin' && state.showAreaView ){
      this.setState({
        showAreaView: false
      })
    }

  }

  componentWillMount() {
    this.firebaseRef = firebase.database();

  }

  updateState(newData, imgId){
    console.log('UPDATE STATE');
    this.setState({
      showAreaView: true,
      imgId: imgId,
      activeObjectId:null
    });

    imgId = (!imgId) ? this.props.activeImgId : imgId;

    let newParentState = { activeImgId: imgId, activeObjectId:null};
    this.props.updateSpecificParentState(newParentState);

    this.saveDataToDatabase(newData);
  }



  saveDataToDatabase(newData){
    this.firebaseRef.ref('projects/' + this.props.projectId ).set(newData);
  }

  saveUserToDatabase(_user){
    let _userName = (_user.name)? _user.name : _user.email;
    let userData = {
      email:_user.email,
      userName: _userName,
      role:"editor",
      permissions:{
        projektID1:false,
        projektID2:false
      }
    }

    this.firebaseRef.ref('users/' + _user.uid ).set(userData);
  }

  handleLogin(e){
    e.preventDefault();
    this.setState({
      user:true
    })
  }

  getObjectId(currentTarget){
    let objectId = currentTarget.getAttribute('objectid');

    do {
      currentTarget = currentTarget.parentNode;
      objectId = currentTarget.getAttribute('objectid');
    }
    while(( objectId === undefined || objectId === null ));

    return objectId;
  }

  handleDeleteClick(e){
    let currentTarget = e.target;
    let objectId = this.getObjectId(currentTarget);

    let _data = this.props.data;
    let _objects = _data.items;

    if( this.state.activeObjectId === objectId ){
      this.ObjectController = null;
    }

    delete _objects[objectId];

    this.updateState(_data);
  }

  handleEditClick(e){
    let currentTarget = e.target;
    let objectId = this.getObjectId(currentTarget);

    console.log('EDIT click objectId: ', objectId);

    this.setState({
      activeObjectId: objectId,
      showAreaView: false

    });
  }

  handleDuplicateClick(e){
    let currentTarget = e.target;
    let objectId = this.getObjectId(currentTarget);

    this.createNewObject(objectId);
  }

  handlePermissionChange(id, val){

    let _users = this.props.users;
    let splitId = id.split('-');
    let userId = splitId[0];
    let projectId = splitId[1];
    _users[userId].permissions[projectId] = val;

    this.setState({
      users: _users,
    });

  }

  getRandomId(){
    return Math.random().toString(36).substr(2, 9);
  }

  toggleAreaView(){
    let _state = (this.state.showAreaView) ? false : true;

    this.setState({
      showAreaView: _state
    })
  }

  createNewObject(duplicateObjId){
    let objects = this.state.objects;

    let _today = new Date();
    let _year = _today.getFullYear(),
        _month = _today.getMonth() + 1,
        _date = _today.getDate(),
        _time = _today.getHours().toString() + _today.getMinutes().toString() + _today.getSeconds().toString();

    let dateStr = _year + '-' + _month + '-' + _date;
    let compressesedDateStr = _year.toString() + _month.toString() + _date.toString() + _time;


    // console.log('length: ', objectsLength, Object.keys(objects)[objectsLength-1] );
    let _id = compressesedDateStr + this.getRandomId();

    let newArea = {
      id:_id,
      title: '-',
      date: dateStr,
      text: '',
      available: true,
      status: "available",
      link:'',
      email:'',
      info: {
        property: {
          title: "Bostadstyp",
          text: "-"
        },
        living_space: {
          title: "Boarea",
          text: "-m²"
        },
        biarea: {
          title: "Biarea",
          text: "-"
        },
        yard_area: {
          title: "Tomtarea",
          text: "-"
        },
        rooms: {
          title: "Antal rum",
          text: "-"
        },
        price: {
          title: "Pris",
          text: "-"
        },
        operating_cost: {
          title: "Driftkostnad",
          text: "-"
        },
        fee: {
          title: "Avgift",
          text: "-"
        }
      }
    };

    if(duplicateObjId){
      newArea.title = objects[duplicateObjId].title;
      newArea.text = objects[duplicateObjId].text;
      newArea.info = objects[duplicateObjId].info;
      newArea.id = _id;
      newArea.date = dateStr;
      newArea.points = null;
    }

    objects[_id]=(newArea);

    let _data = this.state.data;
    _data.items = objects;

    this.setState({
      activeObjectId: _id,
      showAreaView: false,
      data: _data
    });
    this.saveDataToDatabase(_data);

    let newParentState = { activeObjectId: _id};
    // let newParentState = { data: _data, activeObjectId: _id};
    this.props.updateSpecificParentState(newParentState);
    //


  }

  handleProjectEmail(prop, val){
    let email = val;

    console.log('realtor prop: ', prop);
    console.log('realtor email: '+ email);
    let updatedData = this.props.data;

    updatedData.project.email = val;

    this.setState({
      data: updatedData
    })

  }

  saveProjectEmail(prop, val){

    let updatedData = this.state.data;
    this.saveDataToDatabase(updatedData);
  }

  handleUserCreatedFromAdmin(){

  }

  handleUser(user){
    let _id = user.uid;
    let _email = user.email;

    var userProfile = {};

    userProfile.id = _id;
    userProfile.email = _email;

    this.setState({
      user: userProfile
    })
  }
  resetUser(){

    this.setState({
      user: null
    })

    firebase.auth().signOut().then(function() {
      // Sign-out successful.
      console.log('utloggad');
    }, function(error) {
      // An error happened.
    });
  }

  uploadFile(id, file){
    let uniqueId = id.replace('project-image-', '');
    var imgObj = {
      id: id,
      file: file
    }

    this.uploadImage(imgObj, uniqueId);
  }

  uploadImage(obj, chosenImgId){

    var file = obj.file;
    var _id = obj.id;

    // Create a root reference
    var storageRef = firebase.storage().ref();

    var _name = file.name.replace(' ', '-');
    // Create the file metadata
    var metadata = {
      contentType: 'image/jpeg'
    };


    // Upload file and metadata to the object 'images/mountains.jpg'
    var uploadTask = storageRef.child('images/' + _name).put(file, metadata);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on('state_changed', function(snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        this.setState({ loading: true });

        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case 'paused':
            console.log('Upload is paused');
            break;
          case 'running':
            console.log('Upload is running ' + progress);
            break;
        }
      }.bind(this), function(error) {

      switch (error.code) {
        case 'storage/unauthorized':
          // User doesn't have permission to access the object
          break;

        case 'storage/canceled':
          // User canceled the upload
          break;


        case 'storage/unknown':
          // Unknown error occurred, inspect error.serverResponse
          break;
      }
    }, function() {
      // Upload completed successfully, now we can get the download URL
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
        console.log('File available at', downloadURL);

        let _data = this.state.data;
        _data.project.images[chosenImgId] = downloadURL;

        this.setState({
          loading: false,
          data: _data
         })

         this.saveDataToDatabase(_data);

         let newParentState = { activeImgId: chosenImgId};
         this.props.updateSpecificParentState(newParentState);


        // this.setState({ loading: false })

      }.bind(this));
    }.bind(this));

  }

  getBannerImage(){
    if( this.props.data.project.images[this.props.activeImgId] ){
      return (
        <figure className="banner-image">
          <img src={this.props.data.project.images[this.props.activeImgId]} alt="banner" />
        </figure>
      );
    };
  }

  getItems(){
    if( this.props.data.items ){
      let objects = this.props.data.items;

      if(this.state.user && this.props.users[this.state.user.id].role === 'admin'){
        console.log('admin');
        return (
          Object.keys(objects).map((key)=> {
            let objectPoints = (objects[key].points) ? objects[key].points[this.props.activeImgId] : null;
            let count = objects[key].users ? Object.keys(objects[key].users).length : 0;
            let styles = {
              "order":count
            }
            return (
              <li style={this.state.sortOnClicks ? styles : {} } key={'object-key-' +key} className={ (objectPoints) ? 'list__object' : 'list__object missing-area'} objectid={key}>
                <span className="list__object__title">{objects[key].title}
                <span className="list__object__count">{count+ " klick"}</span>

                </span>

                <div className="list__object__menu">
                  <div className="list__object__btn--hover btn-delete" onClick={this.handleDeleteClick}><i className="fas fa-trash-alt"></i></div>
                  <div className="list__object__btn--hover btn-duplicate" onClick={this.handleDuplicateClick}><i className="fas fa-clone"></i></div>
                  <div className="list__object__btn" onClick={this.handleEditClick}><i className="fas fa-pencil-alt"></i></div>
                </div>
                <div className="not-visible fas fa-eye-slash"></div>
              </li>
            );
          })
        );
      }
      else {
        return (
          Object.keys(objects).map((key)=> {
            let objectPoints = (objects[key].points) ? objects[key].points[this.props.activeImgId] : null;

            return (
              <li key={'object-key-' +key} className={ (objectPoints) ? 'list__object' : 'list__object missing-area'} objectid={key}>
                <span className="list__object__title">{objects[key].title}</span>

                <div className="list__object__menu">
                  <div className="list__object__btn" onClick={this.handleEditClick}><i className="fas fa-pencil-alt"></i></div>
                </div>
                <div className="not-visible fas fa-eye-slash"></div>
              </li>
            );
          })
        );
      }


    }
  }

  handleReverseButtons(e){
    let val = e.target.checked;

    // let updatedData = this.props.data;
    //
    // updatedData.project.reverseButtons = val;
    //
    // this.setState({
    //   data: updatedData
    // })

    let updatedData = this.state.data;
    updatedData.project.reverseButtons = val;

    this.saveDataToDatabase(updatedData);
  }

  getImageUploader(){
    if( this.state.user && this.props.users[this.state.user.id].role === 'admin' ){
      let imgsObj = this.props.data.project.images;
      return (
        <div className="image-uploaders">
        {
          Object.keys(imgsObj).map((img)=> (
            <ImageUploader id={"project-image-"+img} key={"project-image-"+img} className={ (img === this.props.activeImgId) ? 'highlight' : '' } imgSrc={this.props.data.project.images[img]} onUpload={this.uploadFile} label="Projektbild" />
          ))
        }
        </div>
      );
    };
  }

  getAdminButtons(){
    if(this.state.user && this.props.users[this.state.user.id].role === 'admin'){

      return (
        <div className="flex-row admin-buttons">
          <div className="">
            <Button onClick={this.createNewObject} text="Skapa nytt objekt"/>
          </div>
          <div className={ (this.state.showAreaView) ? "hidden" : ""}>
            <Button onClick={this.toggleAreaView} text="Ange ytor"/>
          </div>
        </div>
      )
    }
    return false;
  }


  render() {

    let objects = (this.props.data.items) ? this.props.data.items : {};
    let users = this.props.users;
    let projects = this.props.projects;

    let userUid = (this.state.user) ? this.state.user.id : false;
    let userName = (userUid && users) ? this.props.users[userUid].userName : '';
    let userRole = (userUid && users) ? this.props.users[userUid].role : '';
    let userEmail = (userUid && users) ? this.props.users[userUid].email : '';


    return (
      <div className="admin container">
        <div className={(!this.state.user)? 'hidden' : 'user-info wrapper'}>
          <span>{ userName }</span>
          <span className="email">{ userEmail }</span>
          <span className="role">{ userRole }</span>
          <div className="btn--small" onClick={this.resetUser}>Logga ut</div>
        </div>


        <div className={(this.state.user)? 'hidden' : ''}>
          <Login
            handleUser={this.handleUser}
            handleLogOut={this.resetUser}
            handleNewUser={this.saveUserToDatabase}
          />
        </div>

        <div className={(userRole !== 'admin')? 'hidden' : 'users content wrapper'}>
          <h2>Användare</h2>
          <ul className="list cols-2">
          {
            Object.keys(users).map((key)=> (
              <li key={'user-key-'+key} className='list__object user hover' objectid={key}>
                <span className="list__object__title">{users[key].userName}</span>
                <div className="list__object__info">
                  <span className="user__role">{users[key].role}</span>
                  <span className="user__role">{users[key].email}</span>
                </div>
                <div className="hover__content">

                  <div className="flex-row checklist">
                  {
                    Object.keys(projects).map((id)=> (

                      <Checkbox key={'checkbox-' +id} id={key + '-' + id} checked={users[key].permissions[id]} label={projects[id].project.title} onChange={this.handlePermissionChange} />

                    ))
                  }
                  </div>
                </div>
              </li>
            ))
          }
          </ul>

          <h3>Skapa en ny användare</h3>

          <Login
            handleUser={this.handleUserCreatedFromAdmin}
            handleNewUser={this.saveUserToDatabase}
            noLogin="true"
          />

        </div>

        <div className={(!this.state.user)? 'hidden' : ''}>
          <div className='content'>

            {this.getBannerImage()}

              <div className="objects">
                <header className="container__header">
                {this.getImageUploader()}

                  <h2>{this.props.data.project.title}</h2>
                  <p>Här administreras varje bostad och dess yta på bilden. När symbolen <i className="inline-icon fas fa-eye-slash"></i> visas så innebär det att det inte kopplats till någon yta ännu. Varje objekt måste kopplas till den vy som den ska synas i och det är också möjligt att visa ett och samma objekt i olika vyer.</p>

                  <div className={(userRole !== 'admin')? 'hidden' : 'flex-col input-wrapper'}>
                  <h4>Huvudinställningar</h4>
                    <Input id="realtor-email" value={this.state.data.project.email} type="email" onChange={this.handleProjectEmail} label="Ansvarig mäklares e-post" onSave={this.saveProjectEmail} />
                    <div className="flex-row checkbox-wrapper">
                      <label >
                        <input
                          onChange={this.handleReverseButtons}
                          type="checkbox"
                          checked={this.props.data.project.reverseButtons}
                          name="button-position" />
                        Byt plats på knapparna</label>

                    </div>
                  </div>


                </header>

                <div className="btn--small btn--invert" onClick={(e)=>this.setState({sortOnClicks: !this.state.sortOnClicks})}>
                  <span className={this.state.sortOnClicks ? "hidden":""}>Sotera på klick</span>
                  <span className={this.state.sortOnClicks ? "":"hidden"}>Normal sortering</span>
                </div>

                <ul className={this.state.sortOnClicks ? "list cols-2 order" : "list cols-2"}>
                {
                  this.getItems()
                }
                </ul>



                <div className="wrappe">

                  <div className={ (!this.state.showAreaView) ? "active object-view" : "object-view"}>
                    { this.ObjectController }
                  </div>

                  {this.getAdminButtons()}

                </div>

              </div>

          </div>
          <div className={ (this.state.showAreaView) ? "active area-view" : "area-view"}>
            <AdminImage viewBox={this.props.viewBox} updateParentState={this.updateState} activeImgId={this.props.activeImgId} data={this.props.data}/>
            <div className={ (this.state.loading) ? 'loading' : 'loading loaded'}></div>

          </div>
        </div>
      </div>
    );
  }
}

export default AdminController;



// WEBPACK FOOTER //
// ./src/AdminController.js